module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_16.a48d1070.jpg";